module.exports = __webpack_public_path__ + "static/media/ProximaNova-Regular.2d2ae255.woff";